import Hero from "../components/layout/Hero";
import About from "../components/layout/About";
import Projects from "../components/layout/Projects";
import Footer from "../components/layout/Footer";

const Home = () => {
  return (
    <>
      <Hero />
      <About />
      <Projects />
      <Footer />
    </>
  );
};

export default Home;